import React from 'react';
import { Table, Button, Tag } from 'antd';
import { constructColumn, constructColumnFilterSearch, constructColumnFilterRadio } from 'utils/table/table';
import { getConstantLabel, guard } from 'utils/general';

import { useFetchConstant } from 'hooks/constants';

const useFetchConstants = () => {
  const { selection: rateModifierTypes, isLoading: isRateModifierTypesLoading } = useFetchConstant('rateModifierType');
  const { selection: rateModifierSigns, isLoading: isRateModifierSignsLoading } = useFetchConstant('rateModifierSign');

  const selections = { rateModifierTypes, rateModifierSigns };
  const isLoading = isRateModifierTypesLoading || isRateModifierSignsLoading;

  return { selections, isLoading };
};

const constructColumns = (rateModifierTypes, rateModifierSigns, handleOnClickEditTax) => [
  {
    ...constructColumn('Tax Name', 'name', { hasSorter: true }),
    ...constructColumnFilterSearch('name', 'Search Tax Name'),
    render: (text, record) => {
      return (
        <Button type="link" onClick={() => handleOnClickEditTax(record)}>
          {text}
        </Button>
      );
    }
  },
  {
    ...constructColumn('Type', 'type', { hasSorter: true }),
    ...constructColumnFilterRadio('type', rateModifierTypes),
    render: type => getConstantLabel(rateModifierTypes, type)
  },
  {
    ...constructColumn('Amount/Percentage', 'amount', { hasSorter: true }),
    render: (text, record) => {
      const rateModifierTypeObject = rateModifierTypes.find(type => type.code === record.type);
      return guard(
        () =>
          rateModifierTypeObject.isPercentage ? (
            <Tag color="blue" style={{ fontSize: '14px', padding: '5px 10px' }}>{`${text}%`}</Tag>
          ) : (
            <Tag color="green" style={{ fontSize: '14px', padding: '5px 10px' }}>
              {text}
            </Tag>
          ),
        ''
      );
    }
  },
  {
    title: 'Created At',
    dataIndex: 'createdAtWithFormat',
    key: 'createdAtWithFormat',
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt) // Sort by the original date field
  }
];

const TableComponent = ({ data, loading, onSelectedTax }) => {
  const {
    isLoading: isConstantsLoading,
    selections: { rateModifierTypes, rateModifierSigns }
  } = useFetchConstants();

  console.log(rateModifierTypes);
  console.log(rateModifierSigns);

  const handleOnClickEditTax = tax => {
    onSelectedTax(tax);
  };
  return (
    <>
      <Table columns={constructColumns(rateModifierTypes, rateModifierSigns, handleOnClickEditTax)} dataSource={data} loading={loading} />
    </>
  );
};

export default TableComponent;
